import styles from "../../assets/css/securityupdate.module.scss";

const SecurityUpgrade = ({ phone }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        We are upgrading our systems to make our app and your data more secure.
      </div>
      <div className={styles.text}>
        {phone
          ? `Please use your registered phone no +1 ${phone} in order to login
            on Times Club app.`
          : "Please enter/verify your phone number as your new login credentials before December 30th."}
      </div>
      <div className={styles.text}>
        This ensures a safer experience and easy login in the future.
      </div>
    </div>
  );
};
export default SecurityUpgrade;
